import styled from "styled-components";
import IWrapText from "./interface";

const ComponentWrapText = styled.span<IWrapText>`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  white-space: normal;

  ${(props) => props.lineClamp && `
    -webkit-line-clamp: ${props.lineClamp};
  `}

  ${(props) => props.bold && `
    font-weight: bold;
  `}

  ${(props) => props.styleInline && props.styleInline}

`;


export default ComponentWrapText;
